import React from 'react'
import { Icon } from '@ztechapps/webui.util'
import styles from './display.module.scss'

type ButtonProps = {
  onClick: (e: React.MouseEvent) => void
}

const Button = ({ onClick }: ButtonProps) => {
  return (
    <span className="edit" onClick={onClick}>
      <Icon name="pencil" />
    </span>
  )
}

type DisplayProps = {
  children: React.ReactNode
  onClick?: (e: React.MouseEvent | React.KeyboardEvent) => void
  className?: string
}

const Display = ({ children, onClick, className }: DisplayProps) => {
  const onClickHandler = (e: React.MouseEvent | React.KeyboardEvent) => {
    return onClick(e)
  }

  const onKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      onClickHandler(e)
    }
  }

  return (
    <span
      className={`${className} ${styles.hover}`}
      onClick={onClickHandler}
      onKeyDown={onKeyDown}
      role="button"
      tabIndex={0}
      title="Click to edit"
    >
      {children}
    </span>
  )
}

type DisplayWrapperProps = {
  children: React.ReactNode
  className?: string
}

const DisplayWrapper = ({ children, className }: DisplayWrapperProps) => {
  return <span className={className}>{children}</span>
}

export const InlineEdit = {
  Display,
  DisplayWrapper,
  Button,
}
